module.exports = __webpack_public_path__ + "static/img/9.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/9.png
// module id = rHzb
// module chunks = 0